<template>
  <ItemsLister v-bind="itemsListerConfig" :itemsListHelpers="posSourcesListHelpers" />
</template>

<script lang="ts" setup>
import ItemsLister from '@/components/ListingPages/ItemsLister/ItemsLister.vue';
import itemsListerConfig from './config/itemsLister.config';
import usePosSourcesListHelpers from './posSourcesListHelpers';
const posSourcesListHelpers = usePosSourcesListHelpers();
</script>

<style lang="scss" scoped>
</style>